import type { Condition } from "fhir/r4";
import { v4 as uuid } from "uuid";

import * as FHIRUtils from "../fhirutils";

export function buildICD10Condition(
  patientId: string,
  effectiveDate: string,
  code: string,
  name: string,
  updatedBy: string
): Condition {
  const conditionId = uuid();

  const condition: Condition = {
    resourceType: "Condition",
    id: conditionId,
    verificationStatus: {
      coding: [
        {
          system: "http://terminology.hl7.org/CodeSystem/condition-ver-status",
          code: "confirmed",
        },
      ],
    },
    category: [
      {
        coding: [
          {
            system: "http://terminology.hl7.org/CodeSystem/condition-category",
            code: "encounter-diagnosis",
            display: "Encounter Diagnosis",
          },
        ],
      },
    ],
    code: {
      coding: [
        {
          system: "http://hl7.org/fhir/sid/icd-10",
          code: code,
          display: name,
        },
      ],
    },
    subject: {
      reference: "Patient/" + patientId,
    },
    onsetDateTime: effectiveDate,
  };

  return FHIRUtils.addUpdatedBy(condition, updatedBy);
}

export function buildFoodInsecurityCondition(
  patientId: string,
  screeningObservationId: string,
  effectiveDate: string,
  confirmed: boolean,
  updatedBy: string
): Condition {
  const conditionId = uuid();

  const condition: Condition = {
    resourceType: "Condition",
    id: conditionId,
    clinicalStatus: {
      coding: [
        {
          system: "http://terminology.hl7.org/CodeSystem/condition-clinical",
          code: "active",
          display: "Active",
        },
      ],
    },
    verificationStatus: {
      coding: [
        {
          system: "http://terminology.hl7.org/CodeSystem/condition-ver-status",
          code: confirmed ? "confirmed" : "refuted",
          display: confirmed ? "Confirmed" : "Refuted",
        },
      ],
    },
    category: [
      {
        coding: [
          {
            system: "http://hl7.org/fhir/us/core/CodeSystem/condition-category",
            code: "health-concern",
            display: "Health Concern",
          },
        ],
      },
      {
        coding: [
          {
            system:
              "http://hl7.org/fhir/us/sdoh-clinicalcare/CodeSystem/SDOHCC-CodeSystemTemporaryCodes",
            code: "food-insecurity",
            display: "Food Insecurity",
          },
        ],
      },
    ],
    code: {
      coding: [
        {
          system: "http://snomed.info/sct",
          code: "733423003",
          display: "Food insecurity",
        },
        {
          system: "http://hl7.org/fhir/sid/icd-10-cm",
          code: "Z59.4",
          display: "Lack of adequate food and safe drinking water",
        },
      ],
    },
    subject: {
      reference: "Patient/" + patientId,
    },
    onsetPeriod: {
      start: effectiveDate,
    },
    evidence: [
      {
        detail: [
          {
            reference: "Observation/" + screeningObservationId,
          },
        ],
      },
    ],
  };

  return FHIRUtils.addUpdatedBy(condition, updatedBy);
}
